export enum UserRole {
    Admin = 10,
    Instructor = 20,
    Assistant = 30,
}